import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import ILink from '~/data/strapi/types/shared-components/link';

import { useBurgerMenu } from '../../../context';
import styles from './styles.module.css';

interface Props {
  links: ILink[];
  onClick: (link: ILink) => void;
}

const BurgerMainLinks: FC<Props> = ({ links, onClick }) => {
  const { closeMenu } = useBurgerMenu();

  return (
    <ul className={styles.list}>
      {links.map((link) => {
        const href = link.href;

        const isNestedLinks = Boolean(link.links?.length);

        return (
          <li key={link.id}>
            {isNestedLinks || !href ? (
              <div className={styles.nestedLink} onClick={() => onClick(link)}>
                <p>{link.title}</p>
                <Icon name="chevron" className={styles.icon} />
              </div>
            ) : (
              <Link onClick={closeMenu} href={`/${href}`}>
                {link.title}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default BurgerMainLinks;
